import { c as _c } from "react/compiler-runtime";
import { Icon } from "@iconify/react";
import { VisuallyHidden } from "@mantine/core";
export default function ProductSpecifics(t0) {
  const $ = _c(9);
  const {
    product
  } = t0;
  product?.variants?.[0]?.options || null;
  let t1;
  if ($[0] !== product?.specifics) {
    t1 = product?.specifics || [];
    $[0] = product?.specifics;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const specifics = t1;
  if (!specifics || !specifics.length) {
    return null;
  }
  const t2 = `${product?.title} `;
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="text-xl lg:text-2xl"><span className="hidden">{t2}</span>Product Specifications</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== specifics) {
    t4 = specifics && specifics?.length > 0 && <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-1">{specifics?.map(_temp)}</div>;
    $[4] = specifics;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div id="specifics">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(spec, sdx) {
  return <div className="bg-white shadow rounded p-2" key={sdx}><div className="flex gap-2 items-center"><Icon icon="line-md:chevron-triple-right" fontSize={28} /><div className="flex flex-col"><h3 className="text-base lg:text-xl line-clamp-1 text-primary leading-tight">{spec?.stitle}{" "}<VisuallyHidden>{spec?.svalue}</VisuallyHidden></h3><p className="line-clamp-1 leading-tight">{spec?.svalue}</p></div></div></div>;
}